import axios from 'axios';

const API_URL_PROD = 'http://192.168.100.223:8080/prova-cotas-iaupe-api/api/login'
const API_URL_LOCAL = 'http://ht.iaupevirtual.com.br:8080/prova-cotas-iaupe-api/api/login'
const FRONTEND_URL_PROD = 'http://200.143.97.171:3002'
export const USER_NAME_SESSION_ATTRIBUTE_NAME = 'authenticatedUser'
const headers = {'Content-Type':'application/json',
    'Access-Control-Allow-Origin':'*',
    'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS'}

class AuthenticationService {


    executeBasicAuthenticationService(username, password) {
        let user = {
            login: username, 
            senha: password
        };
        return axios.post(API_URL_LOCAL, user)
    }

    async registerSuccessfulLogin(username, password) {
        const token = await this.executeBasicAuthenticationService(username, password)
        sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, username)
        localStorage.setItem('token', token.data.token)
        this.setupAxiosInterceptors(token)
    }

    setupAxiosInterceptors(token) {
        axios.interceptors.request.use(
            (config) => {
                if (this.isUserLoggedIn()) {
                    const novo = "Bearer " + token.data.token
                    config.headers.Authorization = novo
                }
                return config
            }
        )
    }

    logout() {
        // sessionStorage.removeItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
        sessionStorage.clear()
        window.location.href = `${FRONTEND_URL_PROD}`;}

    isUserLoggedIn() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return false
        return true
    }

    getLoggedInUserName() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return ''
        return user
    }
}

export default new AuthenticationService();